import React, { Component } from "react";

class EditUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M6.9,21.4c-0.5,0.1-1.1,0.4-1.6,0.5c-1.7,0.3-1.9,0.7-2.9-0.4c-0.9-0.9-0.7-1.1-0.2-2.8c0.1-0.4,0.3-0.9,0.4-1.4
	c0.3,0.2,0.5,0.4,0.7,0.6c4.3-4.3,8.5-8.5,12.8-12.7c-0.5-0.5-1.1-1.1-1.7-1.6c-0.1,0.1-0.3,0.3-0.4,0.4c-3.7,3.7-7.4,7.4-11.1,11.1
	c-0.3,0.3-0.6,0.7-0.7,1.2C1.4,18.8,0.7,21.4,0,24c0.2,0,5.5-1.5,7.9-2.2c0.3-0.1,0.6-0.2,0.9-0.5c3.8-3.8,7.7-7.7,11.5-11.5
	c0.1-0.1,0.1-0.2,0.2-0.3c-1.2-1.1-2.3-2.2-3.5-3.2c-4.2,4.1-8.4,8.4-12.8,12.8C5.1,19.8,5.9,20.6,6.9,21.4z M15.8,2
	c0.5-0.4,0.9-0.9,1.4-1.4c1-0.9,2.4-0.9,3.3,0c1,0.9,1.9,1.8,2.8,2.8c0.8,0.8,0.9,2.1,0.3,3C23,7.2,22.2,8,21.5,8.7
	c-2.1-2.1-4.1-4.1-6.2-6.2C15.5,2.3,15.7,2.2,15.8,2z"
        />
      </svg>
    );
  }
}

export default EditUpSVG;



// WEBPACK FOOTER //
// ./src/svg/EditUpSVG.jsx